<template>
  <div>
    <div class="center-between mb-4">
      <h1 class="m-0" v-text="$t('vatRate.label', 2)" />
      <button
        class="small"
        @click="$store.dispatch('modals/openModal', { modal: 'editVatRate' , entity: {
          name: '',
          value: 0.00,
        } })"
      >
        +
      </button>
    </div>

    <entity-table
      v-model:sortBy="sortBy"
      v-model:sortDirection="sortDirection"
      :fields="fields"
      :entities="entities"
      :loading="loadingEntities"
      :current-page="currentPage"
      :total-items="totalItems"
      @click:edit="$store.dispatch('modals/openModal', { modal: 'editVatRate', entity: normalizeEntity($event) })"
      @click:delete="$store.dispatch('modals/openModal', { modal: 'deleteVatRate', entity: $event })"
      @update:sort="loadEntities()"
      @update:page="currentPage = $event; loadEntities()"
    />

    <edit-vat-rate-modal @update="loadEntities" />
    <delete-modal type="deleteVatRate" entity-translation-key="vatRate" label="name" @update="loadEntities" />
  </div>
</template>
<script>
import { useStore } from 'vuex';
import useLoadEntities from '@/hooks/api/loadEntities';
import useEntityFields from '@/hooks/api/fields';
import EntityTable from '@/components/shared/EntityTable/EntityTable.vue';
import EditVatRateModal from '@/components/entities/vat_rate/EditVatRateModal.vue';
import DeleteModal from '@/components/shared/DeleteModal.vue';

export default {
  name: 'StoreIndexPage',
  components: { DeleteModal, EditVatRateModal, EntityTable },
  setup() {
    const store = useStore();
    const { vatRate: fields } = useEntityFields();
    const {
      entities,
      loadingEntities,
      currentPage,
      totalItems,
      sortBy,
      sortDirection,
      loadEntities,
    } = useLoadEntities('/vat_rates', { sort: 'name' });

    const loadVatRateWrapper = () => {
      loadEntities();
      store.dispatch('vatRates/LOAD_VAT_RATES');
    };

    const normalizeEntity = (entity) => ({
      ...entity,
      icon: entity?.icon?.['@id'],
    });

    return {
      fields,
      entities,
      loadingEntities,
      currentPage,
      totalItems,
      sortBy,
      sortDirection,
      loadEntities: loadVatRateWrapper,
      normalizeEntity,
    };
  },
};
</script>
